<template>
  <div :class="{ 'chart-container': adaptativeCtn }">
    <Graphic
      :chart-data="datas"
      :options="options"
      :chart-id="id"
      :width="width"
      :height="height"
      :whiteBG="whiteBgd"
    />
  </div>
</template>

<script>
import Graphic from "@/components/DataVisualization/Graphic.vue";

export default {
  name: "PDFModal",
  components: {
    Graphic
  },
  props: {
    selectedAlloys: {
      type: Array,
      default: null
    },
    selectedUnit: {
      type: String,
      default: "MPa"
    },
    id: {
      type: String,
      default: "ID"
    },
    couple: {
      type: Object,
      default: null
    },
    width: {
      type: Number,
      default: undefined,
      required: false
    },
    height: {
      type: Number,
      default: undefined,
      required: false
    },
    whiteBgd: {
      type: Boolean
    },
    adaptativeCtn: {
      type: Boolean
    },
    showLegend: {
      type: Boolean,
      default: true
    },
    rayon: {
      type: Number,
      default: 10
    },
    fontSize: {
      type: Number,
      default: 16
    }
  },
  data: () => {
    return {
      graphicColors: ["#ade4d9", "#85d6a8", "#43a19b", "#57BFFA", "#B69BDF"]
    };
  },
  computed: {
    datas: function() {
      if (!this.selectedAlloys.length) {
        return {
          datasets: [{ label: "No alloy selected", data: [{}] }]
        };
      }
      let tmpDatasets = [];
      let { prop1, prop2 } = this.couple;
      let property1 = prop1.MPaKSI
        ? prop1.property.concat("", this.selectedUnit == "MPa" ? "MPa" : "Ksi")
        : prop1.property;
      let property2 = prop2.MPaKSI
        ? prop2.property.concat("", this.selectedUnit == "MPa" ? "MPa" : "Ksi")
        : prop2.property;
      this.selectedAlloys.forEach((element, index) => {
        tmpDatasets.push({
          label: element.brandName,
          backgroundColor: this.graphicColors[index],
          data: [
            {
              x: this.processNumber(element[property1]),
              y: this.processNumber(element[property2]),
              r: this.rayon
            }
          ]
        });
      });
      return {
        datasets: tmpDatasets
      };
    },
    options: function() {
      if (!this.selectedAlloys.length) {
        return {};
      }
      const unit = this.selectedUnit == "MPa" ? "MPa" : "Ksi";
      let { prop1, prop2 } = this.couple;
      let property1 = prop1.MPaKSI
        ? prop1.property.concat("", unit)
        : prop1.property;
      let property2 = prop2.MPaKSI
        ? prop2.property.concat("", unit)
        : prop2.property;
      let prop1Datas = [],
        prop2Datas = [],
        tmpOptions = {};
      this.selectedAlloys.forEach(element => {
        prop1Datas.push(this.processNumber(element[property1]));
        prop2Datas.push(this.processNumber(element[property2]));
      });
      let interval1 =
        this.getOrderOfMagnitude(
          Math.max(...prop1Datas) - Math.min(...prop1Datas)
        ) / 10;
      let interval2 =
        this.getOrderOfMagnitude(
          Math.max(...prop2Datas) - Math.min(...prop2Datas)
        ) / 10;
      tmpOptions = {
        legend: {
          display: this.showLegend
        },
        scales: {
          xAxes: [
            {
              ticks: {
                suggestedMin: Math.min(...prop1Datas) - interval1,
                suggestedMax: Math.max(...prop1Datas) + interval1,
                fontSize: this.fontSize,
                fontFamily: "Avenir"
              },
              scaleLabel: {
                display: true,
                labelString:
                  prop1.name + (prop1.MPaKSI ? ` (${this.selectedUnit})` : ""),
                fontSize: this.fontSize,
                fontFamily: "Avenir"
              }
            }
          ],
          yAxes: [
            {
              ticks: {
                suggestedMin: Math.min(...prop2Datas) - interval2,
                suggestedMax: Math.max(...prop2Datas) + interval2,
                fontSize: this.fontSize,
                fontFamily: "Avenir"
              },
              scaleLabel: {
                display: true,
                labelString:
                  prop2.name + (prop2.MPaKSI ? ` (${this.selectedUnit})` : ""),
                fontSize: this.fontSize,
                fontFamily: "Avenir"
              }
            }
          ]
        }
      };
      return tmpOptions;
    }
  },
  methods: {
    processNumber: function(stringValue) {
      if (!stringValue || stringValue == "-") return "";
      // if format of value is XXX-XXX
      if (/^[\d,]+[^\d,]+[\d,]+$/.test(stringValue))
        return Number.parseInt(stringValue);
      // to get rid of every non digit character except ','
      let digitString = stringValue.replace(/[^\d,]/g, "");
      return Number(digitString.replace(",", "."));
    },
    getOrderOfMagnitude(n) {
      var order = Math.floor(Math.log(n) / Math.LN10 + 0.000000001);
      return Math.pow(10, order);
    }
  }
};
</script>
<style scoped lang="scss">
.chart-container {
  //flex-grow: 1;
  width: 280px;
  margin: auto;
  min-height: 0;

  > div {
    position: relative;
    height: 100%;
  }
}
</style>